export type NonNullableArr<T extends any[] | null | undefined> = T extends (infer Item)[]
  ? Item extends null | undefined
    ? never
    : Item[]
  : never

export const notNullable = <T>(x: T | null | undefined | false): x is T =>
  x !== undefined && x !== null && x !== false
